import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        When the post arrived, Uncle Vernon, who seemed to be trying to be nice
        to Harry, made Dudley go and get it. They heard him banging things with
        his Smeltings stick all the way down the hall. Then he shouted, ‘There’s
        another one! Mr H. Potter, The Smallest Bedroom, 4 Privet Drive –’ With
        a strangled cry, Uncle Vernon leapt from his seat and ran down the hall,
        Harry right behind him.
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable, authentic replica of Harry Potter’s second Hogwarts
        acceptance letter. In the book, Harry receives this letter after the
        Dursleys - disturbed by the precise address on the first one - move him
        to Dudley’s second bedroom, likely out of fear that someone might know
        how poorly Harry was being treated. Since this second letter never
        appeared in the films, I designed it entirely from scratch, using
        Harry’s first letter as a reference point.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
